import { FloatingDropdownOptionProps } from './types';

export { FloatingDropdownOptionProps };
